import React, { useState, useEffect } from 'react';
import './NextRound.css';
import PhaseMatchCard from './PhaseMatchCard';

function NextRound() {
  const [nextRoundData, setNextRoundData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/phase_next_round.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('Next round predictions not available');
        }
        return response.json();
      })
      .then(data => {
        setNextRoundData(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <div className="next-round-container">
        <div className="loading" style={{ minHeight: '400px' }}>
          Loading next round predictions...
        </div>
      </div>
    );
  }

  if (error || !nextRoundData) {
    return (
      <div className="next-round-container">
        <div className="next-round-content">
          <h2>Next Round Predictions</h2>
          <div className="next-round-info">
            <p className="info-text">
              Next round predictions are not available yet. Run <code>make predict</code>.
            </p>
          </div>
        </div>
      </div>
    );
  }

  const genDate = nextRoundData.generated_at
    ? new Date(nextRoundData.generated_at).toLocaleString('en-AU', { timeZone: 'Australia/Melbourne' })
    : null;

  return (
    <div className="next-round-container">
      <div className="round-content">
        <div className="round-header">
          <h2>{nextRoundData.round_name} {nextRoundData.year}</h2>
          <div className="round-summary">
            <span>{nextRoundData.summary.total} matches</span>
            <span>{nextRoundData.summary.home_wins}H / {nextRoundData.summary.away_wins}A</span>
            <span>avg confidence {nextRoundData.summary.avg_confidence}%</span>
          </div>
          {genDate && (
            <p style={{ fontSize: '0.75rem', color: '#5a7a92', marginTop: 6 }}>Updated {genDate}</p>
          )}
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
          {nextRoundData.matches.map(match => (
            <PhaseMatchCard key={match.mid} match={match} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default NextRound;
